import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { merge, take } from 'rxjs';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { UserInvitationFacade } from '@core/tellent-logic';
import { UserInvitationFlowData } from '@core/tellent-types';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tla-download-credentials-dialog',
  templateUrl: './download-credentials-dialog.component.html',
  styleUrls: ['./download-credentials-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    ButtonComponent,
    TranslatePipe,
    InfoboxComponent,
    IconComponent,
  ],
})
export class DownloadCredentialsDialogComponent extends DialogComponent<
  UserInvitationFlowData,
  UserInvitationFlowData
> {
  private readonly userInvitationFacade = inject(UserInvitationFacade);

  public download(): void {
    this.userInvitationFacade.generatePasswords(this.dialogData.payload!);
    this.handleDownloadSuccess();
  }

  private handleDownloadSuccess(): void {
    merge(
      this.userInvitationFacade.generateTellentPasswordsSuccess$,
      this.userInvitationFacade.generateAppPasswordsSuccess$,
    )
      .pipe(take(1))
      .subscribe(({ payload }) => {
        this.userInvitationFacade.downloadPasswords(payload);
        this.dialogRef.close({});
      });
  }
}
